.InputWrapper {
  display: flex;
  flex-direction: column;
  gap: var(--rv-space-1);
  width: 100%;
}

.ErrorMessage {
  color: var(--rv-danger-ink);
  font-size: var(--rv-text-xs);
  line-height: var(--rv-lh-snug);
}

.Input,
.Input[type='text'],
.Input[type='email'],
.Input[type='number'],
.Input[type='password'],
.Input[type='tel'],
.Input[type='url'],
.Input[type='search'],
.Input[type='datetime-local'],
.Input[type='date'],
textarea.Input,
.Input [data-slot='input'],
.Input[data-slot='textarea'] {
  background-color: var(--rv-bg-app);
  border: 1px solid var(--rv-border);
  border-radius: var(--rv-radius-md);
  color: var(--rv-fg-1);
  font-family: var(--rv-font-ui);
  font-size: var(--rv-text-sm);
  height: var(--rv-space-10);
  outline: none;
  padding: var(--rv-space-2) var(--rv-space-3);
  transition:
    border-color var(--rv-dur-fast) var(--rv-ease-out),
    box-shadow var(--rv-dur-fast) var(--rv-ease-out);
  width: 100%;
}

textarea.Input,
.Input[data-slot='textarea'] {
  height: auto;
  min-height: var(--rv-space-10);
  resize: vertical;
}

/* Sized by its content (AutoGrowTextarea), so a drag handle would only fight it. */
textarea.Input.AutoGrow {
  overflow: hidden;
  resize: none;
}

.Input:hover:not(:disabled, [aria-invalid='true']),
.Input textarea:hover:not(:disabled, [aria-invalid='true']) {
  border-color: var(--rv-neutral-300);
}

.Input:focus,
.Input textarea:focus,
.Input [data-slot='input']:focus,
.Input [data-slot='textarea']:focus {
  border-color: var(--rv-accent);
  box-shadow: var(--rv-shadow-ring-focus);
}

.Input[aria-invalid='true'],
.Input textarea[aria-invalid='true'],
.Input [data-slot='input'][aria-invalid='true'],
.Input [data-slot='textarea'][aria-invalid='true'] {
  border-color: var(--rv-danger);
}

.Input[aria-invalid='true']:focus,
.Input textarea[aria-invalid='true']:focus,
.Input [data-slot='input'][aria-invalid='true']:focus,
.Input [data-slot='textarea'][aria-invalid='true']:focus {
  box-shadow: 0 0 0 3px var(--color-red-500-alpha-25);
}

.Input::placeholder,
.Input textarea::placeholder {
  color: var(--content-core-content-state-disabled);
}

.Input:disabled,
.Input textarea:disabled {
  background-color: var(--rv-bg-app-subtle);
  color: var(--content-core-content-state-disabled);
  cursor: not-allowed;
}

/* Number input — remove the up/down stepper arrows (confusing on price fields) */

.Input[type='number'] {
  appearance: textfield;
}

.Input[type='number']::-webkit-outer-spin-button,
.Input[type='number']::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

/* Date input specific styling */

.Input[type='date'] {
  /* Ensure consistent appearance across browsers */
  appearance: none;

  /* Add extra padding on the right to make room for the calendar icon */
  padding-right: var(--rv-space-10);
}

.Input[type='date']::-webkit-calendar-picker-indicator {
  background: transparent;
  cursor: pointer;
  height: var(--rv-icon-sm);
  opacity: 60%;
  position: absolute;
  right: var(--rv-space-3);
  top: 50%;
  transform: translateY(-50%);
  width: var(--rv-icon-sm);
}

.Input[type='date']::-webkit-calendar-picker-indicator:hover {
  opacity: 100%;
}

.Input[type='date']::-moz-calendar-picker-indicator {
  background: transparent;
  cursor: pointer;
  height: var(--rv-icon-sm);
  opacity: 60%;
  position: absolute;
  right: var(--rv-space-3);
  top: 50%;
  transform: translateY(-50%);
  width: var(--rv-icon-sm);
}

.Input[type='date']::-moz-calendar-picker-indicator:hover {
  opacity: 100%;
}
